import React from 'react'
import renderRoutes from '../../../../../routes/renderRoutes'

// Components Global
import Window from '../../../../../components/Windows/Window'
import { LayoutsTwo, Layouts1, Layouts2 } from '../../../../../components/LayoutsTwoResponsive'
import MenuSidebarResponsive from '../../../../../components/MenuSidebarResponsive'

// Components Customers
import RubberCustomerCreateAndUpdateModal from '../components/RubberCustomerCreateAndUpdateModal'


// imgs
import titleIcon from '../resources/imgs/customer-title-icon.png'


const menuItems = (params) => {
  const { username, attributes_path } = params

  let path = `/${username}/rubber-customer-sellers`

  if (attributes_path) {
    path = `/${username}/rubber-customer-sellers/${attributes_path}`
  }

  return [
    {
      name: 'รายการ',
      title: true
    },
    {
      name: 'เจ้าของสวน',
      icon: 'account_circle',
      link: `${path}/all`,
      linksActive: [
        { url: `${path}/all` },
        { url: `${path}/:objectId` }
      ],
    },
    {
      name: 'ถังขยะ',
      icon: 'delete',
      link: `${path}/trash/all`,
      linksActive: [
        { url: `${path}/trash/all` },
        { url: `${path}/trash/:objectId` }
      ],
    }
  ]
}

const RubberCustomersMenuContainer = (props) => {
  const { business, setting, location, route, match, windowModal, closeWindowModal, history } = props

  return (
    <Window
      title="เจ้าของสวน"
      titleIcon={titleIcon}
      windowModal={windowModal}
      closeWindowModal={closeWindowModal}
      history={history}
      linkClose={`/${match.params.username}`}>

      <LayoutsTwo>
        <Layouts1>
          <MenuSidebarResponsive
            btnAddModal={{
              modalId: 'customerCreateModal',
              text: 'เพิ่มเจ้าของสวน'
            }}
            items={menuItems(match.params)}
          />
        </Layouts1>

        <Layouts2 hideScrollbars>
          { renderRoutes({
            routes: route.routes,
            extraProps: { business, setting },
            location
          }) }
        </Layouts2>
      </LayoutsTwo>

      <RubberCustomerCreateAndUpdateModal {...props} id="customerCreateModal" event="create" match={match} business={business} />
    </Window>
  )
}

export default RubberCustomersMenuContainer
